/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2021. All Rights Reserved.
#*
#*===================================================================
*/
import { createReducer } from '@ngrx/store';
import moment from 'moment';

export const BILLING_PERIODS_STORE_KEY = 'billingPeriods';

const getBillingPeriods = () => {
  const months: string[] = [];
  let currentMonth = moment().add(1, 'month').month();
  if (currentMonth === 0) {
    currentMonth = 13;
  }
  for (; currentMonth >= 0; currentMonth--) {
    const previousMonth = moment()
      .add(1, 'month')
      .subtract(currentMonth + 1, 'month')
      .format('MMM YYYY');

    const currentMonthFormatted = moment().add(1, 'month').subtract(currentMonth, 'month').format('MMM YYYY');

    months.push(`${previousMonth} - ${currentMonthFormatted}`);
  }
  return months;
};

export interface BillingPeriodsState {
  billingPeriods: string[];
  defaultBillingPeriod: string;
}

const initialState: BillingPeriodsState = {
  billingPeriods: getBillingPeriods(),
  defaultBillingPeriod: `${moment().add(-1, 'month').format('MMM YYYY')} - ${moment().format('MMM YYYY')}`,
};

export const billingPeriodReducer = createReducer(initialState);
